/**
 * Declarative FTUE step registry (PEL-515).
 *
 * Section issues (PEL-517..520) call `registerSteps` with their flow's steps;
 * the engine reads the ordered list per flow. Registration is idempotent — a
 * step re-registered with the same id replaces the previous definition (HMR-safe).
 */

import type { FtueStep } from './types'

const flows = new Map<string, FtueStep[]>()

/** Register or replace steps, keyed by `step.flow`. Kept ordered by `order`. */
export function registerSteps(steps: FtueStep[]): void {
  for (const step of steps) {
    const existing = flows.get(step.flow) ?? []
    const next = [...existing.filter((s) => s.id !== step.id), step].sort(
      (a, b) => a.order - b.order,
    )
    flows.set(step.flow, next)
  }
}

export function getFlowSteps(flowId: string | null | undefined): FtueStep[] {
  if (!flowId) return []
  return flows.get(flowId) ?? []
}

export function getStep(
  flowId: string | null | undefined,
  stepId: string | null | undefined,
): FtueStep | null {
  if (!flowId || !stepId) return null
  return getFlowSteps(flowId).find((s) => s.id === stepId) ?? null
}

/** Test/dev helper. */
export function clearRegistry(): void {
  flows.clear()
}
